import React from "react";
import "../../stylesheet/components/divider/YellowDivider.scss";

const YellowDivider: React.FC<{ heading?: string }> = ({ heading = "h1" }) => {
	// if (heading == "h1") {
	// 	return <div className="yellow-divider" />;
	// }
	if (heading == "h2") {
		return <div className="yellow-divider-short" />;
	} else {
		return <div className="yellow-divider" />;
	}
};

export default YellowDivider;
